// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__oLBHg p {
  font-size: 1.8rem;
  font-weight: 600; }
`, "",{"version":3,"sources":["webpack://./src/modules/Core/sub-modules/ui-kit/components/Text/TypewriterText/styles.module.scss"],"names":[],"mappings":"AAAA;EAEQ,iBAAiB;EACjB,gBAAgB,EAAA","sourcesContent":[".container {\n    p {\n        font-size: 1.8rem;\n        font-weight: 600;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__oLBHg`
};
export default ___CSS_LOADER_EXPORT___;
